import { SvgIcon, SvgIconProps } from "@mui/material";

export const SeeAllButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ServiceCardCompletedJobsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30846_61382)">
        <path
          d="M6.25033 9.99935L8.75033 12.4993L13.7503 7.49935M18.3337 9.99935C18.3337 14.6017 14.6027 18.3327 10.0003 18.3327C5.39795 18.3327 1.66699 14.6017 1.66699 9.99935C1.66699 5.39698 5.39795 1.66602 10.0003 1.66602C14.6027 1.66602 18.3337 5.39698 18.3337 9.99935Z"
          stroke="#008B07"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30846_61382">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ServiceCardNoRateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00042 2.56641L9.76613 6.14355L13.7147 6.71726L10.8576 9.50241L11.5318 13.435L8.00042 11.579L4.46899 13.435L5.14328 9.50241L2.28613 6.71726L6.2347 6.14355L8.00042 2.56641Z"
        stroke="#414141"
        strokeWidth="1.37143"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};

export const ServiceCardRateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.49016 1.46655C7.67849 1.01375 8.31996 1.01375 8.50829 1.46656L10.0574 5.19096C10.1368 5.38185 10.3163 5.51227 10.5224 5.5288L14.5432 5.85114C15.032 5.89033 15.2302 6.50039 14.8578 6.81941L11.7944 9.44361C11.6374 9.57807 11.5688 9.78914 11.6168 9.99021L12.5527 13.9138C12.6665 14.3909 12.1475 14.7679 11.729 14.5123L8.28663 12.4097C8.11023 12.3019 7.88829 12.3019 7.71189 12.4097L4.26949 14.5123C3.85098 14.7679 3.33203 14.3909 3.44582 13.9138L4.38175 9.99021C4.42972 9.78914 4.36115 9.57807 4.20413 9.44361L1.14071 6.81941C0.768259 6.50039 0.966479 5.89033 1.45533 5.85114L5.47613 5.5288C5.68221 5.51227 5.86173 5.38185 5.94113 5.19096L7.49016 1.46655Z"
        fill="#F3BC4E"
      />
    </SvgIcon>
  );
};

export const ServiceCardDurationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30846_63272)">
        <path
          d="M10.0003 7.9668V11.3001L12.0837 12.5501M10.0003 4.2168C6.08831 4.2168 2.91699 7.38811 2.91699 11.3001C2.91699 15.2121 6.08831 18.3835 10.0003 18.3835C13.9123 18.3835 17.0837 15.2121 17.0837 11.3001C17.0837 7.38811 13.9123 4.2168 10.0003 4.2168ZM10.0003 4.2168V1.7168M8.33366 1.7168H11.667M16.9411 4.71016L15.6911 3.46016L16.3161 4.08516M3.05951 4.71016L4.30951 3.46016L3.68451 4.08516"
          stroke="#008B07"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30846_63272">
          <rect width="20" height="20" fill="white" transform="translate(0 0.0507812)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ServiceCardVideoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.6667 7.49358C18.6667 6.98873 18.6667 6.73631 18.5668 6.61942C18.4802 6.518 18.3503 6.46418 18.2173 6.47464C18.0641 6.4867 17.8856 6.6652 17.5286 7.02218L14.5 10.0508L17.5286 13.0794C17.8856 13.4363 18.0641 13.6148 18.2173 13.6269C18.3503 13.6374 18.4802 13.5835 18.5668 13.4821C18.6667 13.3652 18.6667 13.1128 18.6667 12.608V7.49358Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8.21744C2 6.81731 2 6.11724 2.27248 5.58246C2.51217 5.11206 2.89462 4.7296 3.36502 4.48992C3.8998 4.21744 4.59987 4.21744 6 4.21744H10.5C11.9001 4.21744 12.6002 4.21744 13.135 4.48992C13.6054 4.7296 13.9878 5.11206 14.2275 5.58246C14.5 6.11724 14.5 6.81731 14.5 8.21744V11.8841C14.5 13.2842 14.5 13.9843 14.2275 14.5191C13.9878 14.9895 13.6054 15.3719 13.135 15.6116C12.6002 15.8841 11.9001 15.8841 10.5 15.8841H6C4.59987 15.8841 3.8998 15.8841 3.36502 15.6116C2.89462 15.3719 2.51217 14.9895 2.27248 14.5191C2 13.9843 2 13.2842 2 11.8841V8.21744Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ServiceCardEquipmentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30910_67080)">
        <path
          d="M6.49967 7.96745L2.33301 10.0508L10.3682 14.0684C10.4775 14.123 10.5322 14.1504 10.5895 14.1611C10.6403 14.1707 10.6924 14.1707 10.7432 14.1611C10.8005 14.1504 10.8552 14.123 10.9645 14.0684L18.9997 10.0508L14.833 7.96745M6.49967 12.1341L2.33301 14.2175L10.3682 18.235C10.4775 18.2897 10.5322 18.317 10.5895 18.3278C10.6403 18.3373 10.6924 18.3373 10.7432 18.3278C10.8005 18.317 10.8552 18.2897 10.9645 18.235L18.9997 14.2175L14.833 12.1341M2.33301 5.88412L10.3682 1.86652C10.4775 1.81186 10.5322 1.78453 10.5895 1.77378C10.6403 1.76425 10.6924 1.76425 10.7432 1.77378C10.8005 1.78453 10.8552 1.81186 10.9645 1.86652L18.9997 5.88412L10.9645 9.90171C10.8552 9.95637 10.8005 9.9837 10.7432 9.99446C10.6924 10.004 10.6403 10.004 10.5895 9.99446C10.5322 9.9837 10.4775 9.95637 10.3682 9.90171L2.33301 5.88412Z"
          stroke="#008B07"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30910_67080">
          <rect width="20" height="20" fill="white" transform="translate(0.666504 0.0507812)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const ServiceOverviewTotalRateStarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.49016 1.46655C7.67849 1.01375 8.31996 1.01375 8.50829 1.46656L10.0574 5.19096C10.1368 5.38185 10.3163 5.51227 10.5224 5.5288L14.5432 5.85114C15.032 5.89033 15.2302 6.50039 14.8578 6.81941L11.7944 9.44361C11.6374 9.57807 11.5688 9.78914 11.6168 9.99021L12.5527 13.9138C12.6665 14.3909 12.1475 14.7679 11.729 14.5123L8.28663 12.4097C8.11023 12.3019 7.88829 12.3019 7.71189 12.4097L4.26949 14.5123C3.85098 14.7679 3.33203 14.3909 3.44582 13.9138L4.38175 9.99021C4.42972 9.78914 4.36115 9.57807 4.20413 9.44361L1.14071 6.81941C0.768259 6.50039 0.966479 5.89033 1.45533 5.85114L5.47613 5.5288C5.68221 5.51227 5.86173 5.38185 5.94113 5.19096L7.49016 1.46655Z"
        fill="#F3BC4E"
      />
    </SvgIcon>
  );
};

export const ServiceOverviewRateStarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30846_42853)">
        <path
          d="M9.53834 1.60996C9.70914 1.19932 10.2909 1.19932 10.4617 1.60996L12.5278 6.57744C12.5998 6.75056 12.7626 6.86885 12.9495 6.88383L18.3123 7.31376C18.7556 7.3493 18.9354 7.90256 18.5976 8.19189L14.5117 11.6919C14.3693 11.8139 14.3071 12.0053 14.3506 12.1876L15.5989 17.4208C15.7021 17.8534 15.2315 18.1954 14.8519 17.9635L10.2606 15.1592C10.1006 15.0615 9.89938 15.0615 9.73937 15.1592L5.14806 17.9635C4.76851 18.1954 4.29788 17.8534 4.40108 17.4208L5.64939 12.1876C5.69289 12.0053 5.6307 11.8139 5.48831 11.6919L1.40241 8.19189C1.06464 7.90256 1.24441 7.3493 1.68773 7.31376L7.05054 6.88383C7.23744 6.86885 7.40024 6.75056 7.47225 6.57744L9.53834 1.60996Z"
          fill="#FEC84B"
        />
      </g>
      <defs>
        <clipPath id="clip0_30846_42853">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const UserVerifiedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 0.00241013C5.77827 -0.0167781 3.55708 0.0786207 1.3463 0.288183C0.987253 0.303172 0.647838 0.447649 0.39755 0.692036C0.147262 0.936423 0.00503879 1.26223 0 1.60274C0.00482545 3.8432 -0.0500684 8.70478 0.770259 10.4977C1.55598 11.8143 2.56747 12.9977 3.76325 13.9996C4.63424 14.7094 6.74237 16 8 16C9.25763 16 11.3658 14.7066 12.2373 13.9996C13.4332 12.9978 14.4447 11.8143 15.2303 10.4977C16.0489 8.70935 15.9391 3.86778 16 1.61988C15.9924 1.2784 15.8478 0.952471 15.5957 0.70831C15.3437 0.464149 15.003 0.320065 14.6428 0.305329C12.4355 0.0968093 10.2183 -0.00429608 8 0.00241013Z"
        fill="#008B07"
      />
      <path
        d="M4.7998 7.11109L7.28869 9.65077L12.2665 4.57141"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MenuButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.2308 8.00002C11.2308 8.7364 11.8507 9.33335 12.6154 9.33335C13.3801 9.33335 14 8.7364 14 8.00002C14 7.26364 13.3801 6.66669 12.6154 6.66669C11.8507 6.66669 11.2308 7.26364 11.2308 8.00002Z"
        fill="#008B07"
      />
      <path
        d="M8 9.33335C7.2353 9.33335 6.61538 8.7364 6.61538 8.00002C6.61538 7.26364 7.2353 6.66669 8 6.66669C8.7647 6.66669 9.38462 7.26364 9.38462 8.00002C9.38462 8.7364 8.7647 9.33335 8 9.33335Z"
        fill="#008B07"
      />
      <path
        d="M3.38461 9.33335C2.61991 9.33335 2 8.7364 2 8.00002C2 7.26364 2.61991 6.66669 3.38461 6.66669C4.14932 6.66669 4.76923 7.26364 4.76923 8.00002C4.76923 8.7364 4.14932 9.33335 3.38461 9.33335Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const GoldenStarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_30910_65262)">
        <path
          d="M9.53834 1.60996C9.70914 1.19932 10.2909 1.19932 10.4617 1.60996L12.5278 6.57744C12.5998 6.75056 12.7626 6.86885 12.9495 6.88383L18.3123 7.31376C18.7556 7.3493 18.9354 7.90256 18.5976 8.19189L14.5117 11.6919C14.3693 11.8139 14.3071 12.0053 14.3506 12.1876L15.5989 17.4208C15.7021 17.8534 15.2315 18.1954 14.8519 17.9635L10.2606 15.1592C10.1006 15.0615 9.89938 15.0615 9.73937 15.1592L5.14806 17.9635C4.76851 18.1954 4.29788 17.8534 4.40108 17.4208L5.64939 12.1876C5.69289 12.0053 5.6307 11.8139 5.48831 11.6919L1.40241 8.19189C1.06464 7.90256 1.24441 7.3493 1.68773 7.31376L7.05054 6.88383C7.23744 6.86885 7.40024 6.75056 7.47225 6.57744L9.53834 1.60996Z"
          fill="#FEC84B"
        />
      </g>
      <defs>
        <clipPath id="clip0_30910_65262">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const MyServicePageButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "15", height: "17", fill: "none" }}
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
    >
      <path
        d="M14.1668 15.833C14.1668 14.67 14.1668 14.0885 14.0233 13.6154C13.7001 12.55 12.8664 11.7164 11.8011 11.3932C11.328 11.2497 10.7465 11.2497 9.58349 11.2497H5.41683C4.25386 11.2497 3.67237 11.2497 3.19921 11.3932C2.13388 11.7164 1.3002 12.55 0.977029 13.6154C0.833496 14.0885 0.833496 14.67 0.833496 15.833M11.2502 4.58301C11.2502 6.65408 9.57123 8.33301 7.50016 8.33301C5.42909 8.33301 3.75016 6.65408 3.75016 4.58301C3.75016 2.51194 5.42909 0.833008 7.50016 0.833008C9.57123 0.833008 11.2502 2.51194 11.2502 4.58301Z"
        stroke="#008B07"
        stroke-width="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CreateServiceButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "14", fill: "none" }}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.66683 0.833008V12.4997M0.833496 6.66634H12.5002"
        stroke="white"
        stroke-width="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
